
@if (true) {
    <div class="modal-body" >
        <form [formGroup]="form" >
            <div class="card overflow-auto"> 
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th>
                                S.No.
                            </th>
                            <th style="text-align: center;">
                                <input type="checkbox" [formControlName]="chkAll" [checked]="bchkAll" (change)="SelectAll()" />
                            </th>
                            <th>
                                Column Name
                            </th>
                            <th>
                                Sequence No.
                            </th>
                            <th>
                                Order By
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="this.MsgType == 1">
                            <td colspan="80">
                                <div class="d-flex align-items-center">
                                    <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                                    <div class="spinner-border" role="status"></div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="this.MsgType == 2">
                            <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                                <span>{{DisplayMessage}}</span>
                            </td>
                        </tr>
                        <tr *ngIf="this.MsgType == 3">
                            <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                            </td>
                        </tr>
                        <!-- ==================================================== -->
        
                        <tr *ngFor="let mDtl of Cdata; let i=index ">
                            <td align="center" width="25px">
                                <input type="hidden" value={{mDtl.ColumnNo}} [formControlName]="mDtl.ColumnNo" /> {{i+1}}
                            </td>
                            <td align="center" width="80px">
                                <input type="checkbox" [checked]="mDtl.IsChecked" [formControlName]="mDtl.chkName" />
                            </td>
                            <td align="left"> {{mDtl.ColumnName}} </td>
                            <td align="center" width="100px">
                                <input class="form-control" type="text" [value]="mDtl.SeqNo" [formControlName]="mDtl.ColumnName">
                            </td>
                            <td align="center" width="80px">
                                <input class="form-control" type="text" [value]="mDtl.OrderBySeq" [formControlName]="mDtl.OrderByName">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
        <div class="d-flex justify-content-center mt-4">
            <button (click)="onColumnUpdate()" type="submit" class="btn btn-primary submit-btn small" >
                view
            </button>
        </div>
    </div>
}@else {
    <!-- <head>
        <title>Lexmantra-Choose Column</title>
    </head> -->
    
    <!-- <body>
        <form [formGroup]="form" (submit)="onColumnUpdate()">
            <p> </p>
            <div class="col-sm-12" style="margin-top: 8px;">
    
                <table width="99%" class="mat-elevation-z8"> -->
                    <!-- <tr>
                <td colspan="4">
                <div  style="border:1px solid #ccc; text-align: left;">
                    <label><h5><b>Column Picker -</b></h5></label>
                </div>
            </td>
            </tr>-->
                    <!-- <tr style="border-bottom:1px solid #ccc;">
                        <th>S.No.</th>
                        <th>
                            All&nbsp;&nbsp;&nbsp;<input type="checkbox" [formControlName]="chkAll" [checked]="bchkAll" (change)="SelectAll()" />
                        </th>
                        <th>Column Name</th>
                        <th>Sequence No.</th>
                        <th>Order By</th>
                    </tr> -->
    
                    <!-- ============== Show Message / Loading ============== -->
                    <!-- <tr *ngIf="this.MsgType == 1">
                        <td colspan="80">
                            <div class="d-flex align-items-center">
                                <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                                <div class="spinner-border" role="status"></div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="this.MsgType == 2">
                        <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                            <span>{{DisplayMessage}}</span>
                        </td>
                    </tr>
                    <tr *ngIf="this.MsgType == 3">
                        <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                        </td>
                    </tr> -->
                    <!-- ==================================================== -->
    
                    <!-- <tr *ngFor="let mDtl of Cdata; let i=index ">
                        <td align="center" width="25px">
                            <input type="hidden" value={{mDtl.ColumnNo}} [formControlName]="mDtl.ColumnNo" /> {{i+1}}
                        </td>
                        <td align="center" width="80px">
                            <input type="checkbox" [checked]="mDtl.IsChecked" [formControlName]="mDtl.chkName" />
                        </td>
                        <td align="left"> {{mDtl.ColumnName}} </td>
                        <td align="center" width="100px">
                            <input style="width:50px; text-align:right;" type="text" [value]="mDtl.SeqNo" [formControlName]="mDtl.ColumnName">
                        </td>
                        <td align="center" width="80px">
                            <input style="width:50px; text-align:right;" type="text" [value]="mDtl.OrderBySeq" [formControlName]="mDtl.OrderByName">
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4" align="center">
                            <button type="submit" id="btnSave" name="Save" class="btn btn-primary">Save</button>
                        </td>
                    </tr>
    
                </table>
            </div>
    
        </form>
    
    </body> -->
}


